import Modal from './Modal'

export default Modal
export { ModalPortalTarget } from './Modal'
export { default as ModalBackdrop } from './ModalBackdrop'

export {
  default as ModalContainer,
  entrances as entranceTransitions,
  exits as exitTransitions
} from './ModalContainer'
export {
  CloseButton,
  PrevButton,
  getBodyMaxHeight,
  headerHeight as modalHeaderHeight,
  footerHeight as modalFooterHeight
} from './Elements'
